import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { useEffect, useState } from 'react';
import { Button, Dimmer, Form, Header, Loader, Message, TextArea } from 'semantic-ui-react';
import './Contact.css';
import EastIcon from '@mui/icons-material/East';
import gif from "../../images/glowgif01.gif";

export const Contact = () => {
  const [showErrMsg, setShowErrMsg] = useState<string | null>(null);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState<boolean>(false);
  const [form, setForm] = useState<{
    fullName: string,
    contactNo: string,
    emailId: string,
    about: string
  }>({
    fullName: "",
    contactNo: "",
    emailId: "",
    about: "",
  })

  useEffect(() => {
    if (showSuccessMsg) {
      setTimeout(() => {
        setShowSuccessMsg(false);
      },2000)
    }
  }, [showSuccessMsg])
  const handleChange = (e: any, {value, name}: any) => {
    setForm({
      ...form,
      [name]: value
    })
  }

  const submitForm = async () => {
    let url = process.env.REACT_APP_FORM_URL;
    console.log(url,'ssssssss');
    if (!url) {
      return;
    }

    // Replace placeholders with form data
    url = url.replace("{{FullName}}", encodeURIComponent(form.fullName));
    url = url.replace("{{ContactNo}}", encodeURIComponent(form.contactNo));
    url = url.replace("{{EmailID}}", encodeURIComponent(form.emailId));
    url = url.replace("{{About}}", encodeURIComponent(form.about));
    
    // Open Microsoft Form in a new tab (Microsoft Forms requires user interaction)
    window.open(url, '_blank');
    
    // Reset form and show success message
    setForm({
      fullName: "",
      contactNo: "",
      emailId: "",
      about: ""  
    })
    setShowSuccessMsg(true);
  }

  const validator = (name: string, value: string) => {
    switch(name) {
      case "fullName":
        return value.length >= 3;
      case "collegeName":
        return value.length >= 3;
      case "contactNo":
        return String(value)
          .toLowerCase()
          .match(
            /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
          );
      case "emailId":
        return String(value)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
        }
  }

  const handleSubmit = async () => {
    if (form.fullName && form.about && form.contactNo && form.emailId) {
      if (!validator("fullName", form.fullName)) {
        setShowErrMsg("Full Name should be atleast 3 characters");
        return;
      }

     

      if (!validator("contactNo", form.contactNo)) {
        setShowErrMsg("Invalid Contact No");
        return;
      }

      if (!validator("emailId", form.emailId)) {
        setShowErrMsg("Invalid Email Id");
        return;
      }
      if (!validator("collegeName", form.about)) {
        setShowErrMsg("About should be atleast 3 characters");
        return;
      }

      setShowErrMsg(null);
      await submitForm();
    } else {
      setShowErrMsg("* fields are required")
    }
  }

  return (
    <div className='apply' >
       <div className='center3 animate'>
            <img src={gif} className='logoIS2' />

              
            
             </div>
      <div  className='apply__left12'>
     
   
      <div className='apply__left2'>
        <h1 >
        Contact Information
  
        </h1>
        <p>
          Gain enough knowledge to help scale through the  industry
        </p>
        <div className='apply-flex'>
                <div  className='apply-menu-item2'>
                  <LocalPhoneOutlinedIcon  className='icon'></LocalPhoneOutlinedIcon> 
                  <div >
                  {/* <div style={{fontSize:'12px',color:'rgba(255, 255, 255, 0.8)'}} >Tel</div> */}
                  <div  > US: +1 720-414-5030</div>
                  <div  > IN: +91 8374503904</div>
                  </div>
                </div>
                <div  className='apply-menu-item2'>
                   <EmailOutlinedIcon className='icon'></EmailOutlinedIcon>
                  
                     <div >
                    
                  <div  >recruiter@intelle-sphere.com  </div>
                  </div>
                </div>
                <div  className='apply-menu-item2'>
                   <LocationOnOutlinedIcon className='icon'></LocationOnOutlinedIcon>
                   <div >
                   <div style={{color:'white',fontWeight:'500',marginTop:10,fontFamily:'mont'}}>US Head Quarters:</div>                  <div  > 
                   IntelleSphere LLC<br></br>
2879, Grand Helios Way, Henderson, NV 89052 USA

                    
                    </div>
                  </div>
                  <div >
                   <div style={{color:'white',fontWeight:'500',marginTop:10,fontFamily:'mont'}}>INDIA Address:</div>                  <div  > 
                   IntelleSphere Pvt.Ltd.<br></br>
                   AV HUB, 4th floor 
                   C9RP+6RJ, Vittal Rao Nagar, HITEC City, Hyderabad, Telangana 500081</div>
                  </div>
                </div>
                </div>
      </div>
      <div className='apply__right'>
      <div style={{color:'white',fontSize:30,fontFamily:'michr',paddingBottom:20,zIndex:1}}>Get In Touch</div>
        <Form onSubmit={handleSubmit}>
          <Form.Input
            fluid
            className='input'
            label='Full Name*'
            placeholder='Full Name'
            name="fullName"
            onChange={handleChange}
            value={form.fullName}
          />
        
          <Form.Input
            fluid
            label='Contact No*'
            placeholder='Contact No'
            name="contactNo"
            onChange={handleChange}
            value={form.contactNo}
          />
          <Form.Input
            fluid label='Email Id*'
            placeholder='Email Id'
            name="emailId"
            onChange={handleChange}
            value={form.emailId}
          />
         
         <Form.Field
            control={TextArea}
            label='About'
            placeholder='...'
            name="about"
            onChange={handleChange}
            value={form.about}
          />
          {showErrMsg && <div style={{color: "red"}}>{showErrMsg}</div>}
          <Dimmer active={showLoader}>
            <Loader />
          </Dimmer>
          <div className='submit_Container'>
          <div className='apply__btn2'>
            <Form.Field  control={Button}  className='button'>
              Submit
              <EastIcon className='arrow' ></EastIcon>
            </Form.Field>
          </div>
          </div>
          
        </Form>
        {showSuccessMsg && <Message positive>
          <Message.Header>Application successfully submitted!!</Message.Header>
        </Message>}
      </div>
      </div>
    </div>
  )
}